import type { ISuccessOperationResult } from '../types';

export function createSuccessOperationResult<TData>(
  data: TData,
): ISuccessOperationResult<TData> {
  return {
    success: true,
    data,
  };
}
